import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
export async function getAllBlockIp() {
  try {
    const response = await RestMethod.GET(
      "/global-configuration/ehs-module/get-all-block-ip"
    );
    console.log("response data is", response.data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createBlockIp(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/block-ip",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function updateBlockIp(id, data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/update-block-ip/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteBlockedIp(id) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/delete-blocked-ip/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function forceLogOut(data) {
  try {
    const response = await RestMethod.POST(
      "global-configuration/ehs-module/force-logout",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function excelExport(filter) {
  let url = "global-configuration/ehs-module/excel-export?";

  if (filter) url += filter;
  try {
    const response = await RestMethod.POST(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
